var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"button-round",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.removeAlert()}}},[_c('BaseIcon',{attrs:{"icon":"trash","screenReaderLabel":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }